<template>
  <base-page
    :title="'Users'"
  >
    <template #actionButton>
      <v-btn
        rounded
        outlined
        color="primary"
        :to="{ name: 'create-user' }"
      >
        <v-icon left>
          add
        </v-icon>

        Add User
      </v-btn>
    </template>
    <template #main>
      <user-table />
    </template>
  </base-page>
</template>
<script>
  import { mapActions } from 'vuex'
  import BasePage from "../BasePage"
  import UserTable from "../../components/User/UserTable"

  export default {
    components: {
      UserTable,
      BasePage,
    },
    created() {
      this.initUsers()
    },
    methods: {
      ...mapActions([ 'initUsers' ])
    },
  }
</script>
